import React from 'react';
import { Card as CardAntd} from 'antd';

import styles from './Card.module.scss';

interface CardProps {
  title?: string;
  children: React.ReactNode;
}

const Card = ({ title, children, ...rest }: CardProps) => {
  return (
    <CardAntd
      title={title}
      {...rest}
      className={styles.card}
    >
      {children}
    </CardAntd>
  )
}

export default Card;